import { render, staticRenderFns } from "./StatList.vue?vue&type=template&id=6e446786&scoped=true&"
import script from "./StatList.vue?vue&type=script&lang=js&"
export * from "./StatList.vue?vue&type=script&lang=js&"
import style0 from "./StatList.vue?vue&type=style&index=0&id=6e446786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e446786",
  null
  
)

component.options.__file = "StatList.vue"
export default component.exports